import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg`
  width: 100px;
  height: 100px;
`;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  width: "150",
  height: "150",
  "aria-label": "Cookie icon",
  viewBox: "0 0 85 85"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-5.3%",
  y: "-3.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: "0",
  dy: "2",
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "4",
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
})))), /*#__PURE__*/React.createElement("g", {
  id: "BNNVARA---modal-v1.0",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "BNNVARA-1.0-mob---modal-[variant-1]",
  transform: "translate(-144.000000, -134.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "modal",
  filter: "url(#filter-1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "window",
  transform: "translate(16.000000, 112.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-47",
  transform: "translate(132.000000, 24.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-46",
  transform: "translate(6.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.1894,36.0118 C10.1894,36.0118 13.6894,39.4498 18.0054,43.6878 C22.3214,47.9278 25.8194,51.3658 25.8194,51.3658 C25.8194,51.3658 22.3214,47.9278 18.0054,43.6878 C13.6894,39.4498 10.1894,36.0118 10.1894,36.0118 Z",
  id: "Stroke-2",
  stroke: "#E60000",
  strokeWidth: "3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.9306,4.9804 C31.7826,10.0784 32.9186,8.2404 29.1766,14.3004 C25.9966,19.4484 23.4206,23.6224 23.4206,23.6224 C23.4206,23.6224 25.9966,19.4484 29.1766,14.3004 C32.3546,9.1544 34.9306,4.9804 34.9306,4.9804 Z",
  id: "Stroke-4",
  stroke: "#E60000",
  strokeWidth: "3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.1708,40.8906 C41.1708,40.8906 44.9108,39.4446 49.5228,37.6626 C54.1368,35.8786 57.8768,34.4326 57.8768,34.4326 C57.8768,34.4326 54.1368,35.8786 49.5228,37.6626 C44.9108,39.4446 41.1708,40.8906 41.1708,40.8906 Z",
  id: "Stroke-6",
  stroke: "#E60000",
  strokeWidth: "3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.2022,19.7402 C59.4922,19.9002 58.7582,20.0002 58.0002,20.0002 C52.4782,20.0002 48.0002,15.5242 48.0002,10.0002 C48.0002,9.3082 48.0722,8.6322 48.2042,7.9802 C48.1342,7.9822 48.0702,8.0002 48.0002,8.0002 C43.7762,8.0002 40.3542,4.7162 40.0582,0.5702 C38.0882,0.2142 36.0722,0.0002 34.0002,0.0002 C15.2222,0.0002 0.0002,15.2222 0.0002,34.0002 C0.0002,52.7782 15.2222,68.0002 34.0002,68.0002 C52.7782,68.0002 68.0002,52.7782 68.0002,34.0002 C68.0002,31.2062 67.6262,28.5102 66.9922,25.9122 C63.6342,25.4862 60.9262,22.9962 60.2022,19.7402 Z",
  id: "Stroke-8",
  stroke: "#000000",
  strokeWidth: "3"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-13",
  transform: "translate(28.000000, 58.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,2 L6,0",
  id: "Fill-10",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,2 L6,0",
  id: "Stroke-12",
  stroke: "#000000",
  strokeWidth: "2"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-17",
  transform: "translate(2.000000, 24.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.2744,8.3868 L0.0004,0.0008",
  id: "Fill-14",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.2744,8.3868 L0.0004,0.0008",
  id: "Stroke-16",
  stroke: "#000000",
  strokeWidth: "2"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-21",
  transform: "translate(62.000000, 31.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,1 L4.342,2.444",
  id: "Fill-18",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,1 L4.342,2.444",
  id: "Stroke-20",
  stroke: "#000000",
  strokeWidth: "2"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-25",
  transform: "translate(10.000000, 16.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,4 L6.264,0.368",
  id: "Fill-22",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,4 L6.264,0.368",
  id: "Stroke-24",
  stroke: "#000000",
  strokeWidth: "2"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-29",
  transform: "translate(12.000000, 52.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4,0 L0.52,6.33",
  id: "Fill-26",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4,0 L0.52,6.33",
  id: "Stroke-28",
  stroke: "#000000",
  strokeWidth: "2"
})), /*#__PURE__*/React.createElement("path", {
  d: "M48.3232,64 L48.3232,58",
  id: "Stroke-30",
  stroke: "#000000",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.3232,54 L35.9992,48",
  id: "Stroke-32",
  stroke: "#000000",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.3232,18 L37.9992,14",
  id: "Stroke-34",
  stroke: "#000000",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.1132,47.2774 L46.9332,46.8234",
  id: "Stroke-36",
  stroke: "#000000",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20,30 L12.934,26.824",
  id: "Stroke-38",
  stroke: "#000000",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.252,10.2266 L11.072,9.7726",
  id: "Stroke-40",
  stroke: "#000000",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5332,38.6192 L27.4672,35.4432",
  id: "Stroke-42",
  stroke: "#000000",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.6368,33.6152 L35.2768,24.7972",
  id: "Stroke-44",
  stroke: "#000000",
  strokeWidth: "2"
})))))))));